__turbopack_context__.v({
  "container": "styles-module__fz5KWW__container",
  "title": "styles-module__fz5KWW__title",
});
